import { render, staticRenderFns } from "./InvoiceSidebar.vue?vue&type=template&id=4feed4bf&scoped=true&"
import script from "./InvoiceSidebar.vue?vue&type=script&lang=js&"
export * from "./InvoiceSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feed4bf",
  null
  
)

export default component.exports